module.exports = __webpack_public_path__ + "745c825c7e8a0b53a86bc40aca29adb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/accessory-detail-content/icon_pdf_dark.png
// module id = 883
// module chunks = 0 1